import React, { useState, useEffect, useRef } from "react";
import "./RegisterForm.scss";
import { useDispatch, useSelector } from "react-redux";
import FormTextInput from "../FormTextInput/FormTextInput";
import FormRadio from "../FormRadio/FormRadio";
import FormSelect from "../FormSelect/FormSelect";
import Consent from "../Consent/Consent";
import Submit from "../Submit/Submit";
import { formSubmission } from "../../redux/actions/contentActions";

//recaptcha v3
import ReactRecaptcha3 from "react-google-recaptcha3";

function RegisterForm(props) {
    const sparkContainer = useRef();
    const form = props.form;
    const dispatch = useDispatch();
    const [open, setOpen] = useState(-1);

    const [formValue, setFormValue] = useState({
        formName: "contact",
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        //address: '',
        postalcode: "",
        realtor: "",
        brokerage: "",
        hearabout: "",
        pricerange: "",
        garage_choice: "",
        consent: "",
    });

    const handleSubmit = (e) => {
        e.preventDefault();

        //make an action pass the data do the api get the response update the thing
        //infiltrate the dealer. Find the supplier
        if (!props.submitting) {
            //now check if we pass recaptcha if we don't then we will not be submitting

            ReactRecaptcha3.getToken().then(
                (token) => {
                    //grab spark fields
                    var fields = sparkContainer.current.children;
                    var values = {};
                    for (var i = 0; i < fields.length; i++) {
                        values[fields[i].name] = fields[i].value;
                    }

                    var submitData = Object.assign({}, formValue, values);

                    dispatch(
                        formSubmission(
                            Object.assign({}, submitData, {
                                recaptchaToken: token,
                            })
                        )
                    );
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };

    const hasErrors = () => {
        if (props.consent_error) return true;

        for (var i = 0; i < form.length; i++) {
            if (typeof form[i].error !== "undefined")
                if (form[i].error === true) return true;
        }

        return false;
    };

    //setup for recaptcha

    useEffect(() => {
        ReactRecaptcha3.init("6LcIOdwqAAAAABa7ncUdPwSmV8urcdYuFr-SpW6X").then(
            (status) => {}
        );
    }, []);

    if (!props.submitted) {
        return (
            <div className="register-form-container">
                <form className="register-form">
                    <FormTextInput
                        index={0}
                        name={form[0].name}
                        label={form[0].label}
                        value={formValue.firstName}
                        formValue={formValue}
                        error={form[0].error || false}
                        errorText={form[0].error_text}
                        setFormValue={setFormValue}
                        required
                        inputSectionChild
                    />
                    <FormTextInput
                        index={1}
                        name={form[1].name}
                        label={form[1].label}
                        value={formValue.lastName}
                        error={form[1].error || false}
                        errorText={form[1].error_text}
                        formValue={formValue}
                        setFormValue={setFormValue}
                        required
                        inputSectionChild
                    />
                    <FormTextInput
                        index={2}
                        name={form[2].name}
                        label={form[2].label}
                        value={formValue.email}
                        error={form[2].error || false}
                        errorText={form[2].error_text}
                        formValue={formValue}
                        setFormValue={setFormValue}
                        required
                        email
                        inputSectionChild
                    />
                    <FormTextInput
                        index={3}
                        name={form[3].name}
                        label={form[3].label}
                        value={formValue.phone}
                        error={form[3].error || false}
                        errorText={form[3].error_text}
                        formValue={formValue}
                        setFormValue={setFormValue}
                        required
                        inputSectionChild
                        phoneNumber
                    />
                    {/*
          <FormTextInput
            index={4}
            name={form[4].name}
            label={form[4].label}
            value={formValue.address}
            error={form[4].error || false}
            errorText={form[4].error_text}
            formValue={formValue}
            setFormValue={setFormValue}
            required
            inputSectionChild
          />
          */}
                    <FormTextInput
                        index={5}
                        name={form[5].name}
                        label={form[5].label}
                        value={formValue.postalCode}
                        formValue={formValue}
                        setFormValue={setFormValue}
                        error={form[5].error || false}
                        errorText={form[5].error_text}
                        required
                        inputSectionChild
                        postalCode
                    />
                    <FormRadio
                        index={6}
                        name={form[6].name}
                        label={form[6].label}
                        buttons={form[6].choices}
                        value={formValue.realtorStatus}
                        formValue={formValue}
                        setFormValue={setFormValue}
                        error={form[6].error || false}
                        errorText={form[6].error_text}
                        full
                    />
                    <FormTextInput
                        name={form[7].name}
                        label={form[7].label}
                        value={formValue.brokerage}
                        formValue={formValue}
                        conditional={true}
                        cond_field={formValue.realtor}
                        cond_value={"Yes"}
                        setFormValue={setFormValue}
                        full
                    />
                    <FormSelect
                        name={form[8].name}
                        label={form[8].label}
                        value={form[8].label}
                        options={form[8].choices}
                        formValue={formValue}
                        open={open}
                        setOpen={setOpen}
                        index={0}
                        formIndex={8}
                        error={form[8].error || false}
                        setFormValue={setFormValue}
                        required
                    />
                    <FormSelect
                        name={form[9].name}
                        label={form[9].label}
                        options={form[9].choices}
                        formValue={formValue}
                        open={open}
                        setOpen={setOpen}
                        index={1}
                        formIndex={9}
                        error={form[9].error || false}
                        setFormValue={setFormValue}
                        required
                    />
                    <FormSelect
                        name={form[10].name}
                        label={form[10].label}
                        options={form[10].choices}
                        formValue={formValue}
                        open={open}
                        setOpen={setOpen}
                        setFormValue={setFormValue}
                        index={2}
                        formIndex={10}
                        error={form[10].error || false}
                        full
                        required
                    />
                    <Consent
                        text="I consent to receive electronic communications with news and information about Park & Lake and other related Graywood Developments and Falconcrest projects."
                        name="consent"
                        formValue={formValue}
                        setFormValue={setFormValue}
                        error={props.consent_error}
                        required
                    />
                    <Submit
                        buttonText="Submit"
                        requiredText="Required"
                        formValue={formValue}
                        handleSubmit={handleSubmit}
                    />
                    <div
                        className="hidden-spark-fields"
                        style={{ display: "none" }}
                        ref={sparkContainer}
                    >
                        <input
                            type="hidden"
                            id="tracking_cookie_id"
                            name="tracking_cookie_id"
                        />
                        <input
                            type="hidden"
                            id="tracking_page_url"
                            name="tracking_page_url"
                        />
                        <input
                            type="hidden"
                            id="tracking_referrer"
                            name="tracking_referrer"
                        />
                        <input
                            type="hidden"
                            id="tracking_initial_landing_url"
                            name="tracking_initial_landing_url"
                        />
                        <input
                            type="hidden"
                            id="tracking_initial_referrer"
                            name="tracking_initial_referrer"
                        />
                        <input
                            type="hidden"
                            id="tracking_utm_source"
                            name="tracking_utm_source"
                        />
                        <input
                            type="hidden"
                            id="tracking_utm_medium"
                            name="tracking_utm_medium"
                        />
                        <input
                            type="hidden"
                            id="tracking_utm_campaign"
                            name="tracking_utm_campaign"
                        />
                        <input
                            type="hidden"
                            id="tracking_utm_term"
                            name="tracking_utm_term"
                        />
                        <input
                            type="hidden"
                            id="tracking_utm_content"
                            name="tracking_utm_content"
                        />
                    </div>
                    <div
                        className="required-fields"
                        style={{
                            gridColumn: "3 / 5",
                            justifySelf: "center",
                        }}
                    >
                        <span className="required-star">*</span> Required
                    </div>
                    {hasErrors() && false && (
                        <div className="form-errors">
                            Please fill out all required fields.
                        </div>
                    )}
                </form>
            </div>
        );
    } else {
        return (
            <div className="register-form-container submitted">
                <h2 className="thank-you-message">
                    Thank you for registering.
                </h2>
            </div>
        );
    }
}

export default RegisterForm;
